import {isNewAPI} from './utils';
import logger from './logger';
import {Platform} from 'react-native';
import {showTokenExpireAlertWeb} from '../service/network_access';
export function completeModuleEvaluation({loginToCourse, courseDetails}) {
   try {
      var loginToCourseJSON = JSON.parse(loginToCourse);
      var courseDetailsJSON = JSON.parse(courseDetails);
      const scratchPadRecord = isNewAPI
         ? loginToCourseJSON?.ScratchPadRecordsList
         : loginToCourseJSON.scratchPadRecord;
      for (const element of scratchPadRecord) {
         const moduleId = isNewAPI ? element.ModuleNumber : element.ModuleID;
         const loginCourseModuleID = parseInt(moduleId, 10) - 1;

         const completed = isNewAPI
            ? element.ModuleCompleted
            : element.Completed;

         if (
            completed == 1 &&
            courseDetailsJSON.DataSet.courseModule.CourseModule[
               loginCourseModuleID
            ]
         ) {
            courseDetailsJSON.DataSet.courseModule.CourseModule[
               loginCourseModuleID
            ].CourseModuleComplete = true;
            courseDetailsJSON.DataSet.courseModule.CourseModule[
               loginCourseModuleID
            ].PreTestAvailable = false;
         } else {
            if (
               Array.isArray(
                  courseDetailsJSON.DataSet.courseModule.CourseModule,
               )
            ) {
               courseDetailsJSON.DataSet.courseModule.CourseModule[
                  loginCourseModuleID
               ].CourseModuleComplete = false;
            } else {
               courseDetailsJSON.DataSet.courseModule.CourseModuleComplete =
                  false;
            }

            const isPreEnabled = isNewAPI
               ? element.ModulePreTestEnabled
               : element.PreTestEnabled;
            if (isPreEnabled == 0) {
               if (
                  Array.isArray(
                     courseDetailsJSON.DataSet.courseModule.CourseModule,
                  ) &&
                  courseDetailsJSON.DataSet.courseModule.CourseModule[
                     loginCourseModuleID
                  ]
               ) {
                  courseDetailsJSON.DataSet.courseModule.CourseModule[
                     loginCourseModuleID
                  ].PreTestAvailable = false;
               } else {
                  courseDetailsJSON.DataSet.courseModule.CourseModule.PreTestAvailable =
                     false;
               }
            } else {
               if (
                  Array.isArray(
                     courseDetailsJSON.DataSet.courseModule.CourseModule,
                  ) &&
                  courseDetailsJSON.DataSet.courseModule.CourseModule[
                     loginCourseModuleID
                  ]
               ) {
                  courseDetailsJSON.DataSet.courseModule.CourseModule[
                     loginCourseModuleID
                  ].PreTestAvailable = true;
               } else {
                  courseDetailsJSON.DataSet.courseModule.CourseModule.PreTestAvailable =
                     true;
               }
            }
         }
      }

      return JSON.stringify(courseDetailsJSON);
   } catch (error) {
      showTokenExpireAlertWeb();
      logger({error});
   }
}

export function ModuleAvailable(param) {
   var courseDetailsJSON = param.courseDetails;
   for (let x of courseDetailsJSON.DataSet.courseModule.CourseModule) {
      x.ModuleAvailable = false;
   }

   if (
      courseDetailsJSON.DataSet.courseGeneralData.isSequencialModules ===
         'true' &&
      courseDetailsJSON.DataSet.courseGeneralData.isFinalModule != 'true'
   ) {
      for (let x of courseDetailsJSON.DataSet.courseModule.CourseModule) {
         if (x.CourseModuleComplete === true) {
            const temID = parseInt(x.CourseModuleID) + 1;
            const modulesLength =
               courseDetailsJSON.DataSet.courseModule.CourseModule.length;
            if (temID < modulesLength) {
               courseDetailsJSON.DataSet.courseModule.CourseModule[
                  temID
               ].ModuleAvailable = true;
            }
         }
      }
   }

   if (
      courseDetailsJSON.DataSet.courseGeneralData.isSequencialModules !=
         'true' &&
      courseDetailsJSON.DataSet.courseGeneralData.isFinalModule === 'true'
   ) {
      let completed = true;

      for (let x of courseDetailsJSON.DataSet.courseModule.CourseModule) {
         x.ModuleAvailable = true;
         const tempModuleLeng =
            courseDetailsJSON.DataSet.courseModule.CourseModule.length - 1;
         const tempID = parseInt(x.CourseModuleID);
         if (tempID != tempModuleLeng) {
            if (x.CourseModuleComplete === 'false') {
               completed = false;
            }
         }
      }

      courseDetailsJSON.DataSet.courseModule.CourseModule[
         courseDetailsJSON.DataSet.courseModule.CourseModule.length - 1
      ].ModuleAvailable = completed;
   }

   if (
      courseDetailsJSON.DataSet.courseGeneralData.isSequencialModules !=
         'true' &&
      courseDetailsJSON.DataSet.courseGeneralData.isFinalModule != 'true'
   ) {
      for (let x of courseDetailsJSON.DataSet.courseModule.CourseModule) {
         x.ModuleAvailable = true;
      }
   }
   const res = JSON.stringify(isModuleAvailable(courseDetailsJSON));
   return res;
}

export function isModuleAvailable(courseDetails) {
   for (let x of courseDetails.DataSet.courseModule.CourseModule) {
      if (x.ModuleAvailable) {
         x.ModuleAvailable = true;
         logger('x.ModuleAvailable ' + x.ModuleAvailable);
      } else {
         if (x.CourseModuleID != 0) {
            logger(`STOP THE MODULE:: ${ModuleAvailable}}`);
            x.ModuleAvailable = false;
         } else {
            x.ModuleAvailable = true;
         }
      }
   }
   return courseDetails;
}
export function CourseModuleCompletedCount({loginToCourse, courseDetails}) {
   try {
      var loginToCourseJSON = JSON.parse(loginToCourse);
      var courseDetailsJSON = JSON.parse(courseDetails);
      const scratchPadRecord = isNewAPI
         ? loginToCourseJSON?.ScratchPadRecordsList
         : loginToCourseJSON.scratchPadRecord;
      var isCompleteCount = 0;
      for (const element of scratchPadRecord) {
         const moduleId = isNewAPI ? element.ModuleNumber : element.ModuleID;
         const loginCourseModuleID = parseInt(moduleId, 10) - 1;

         const completed = isNewAPI
            ? element.ModuleCompleted
            : element.Completed;

         if (
            completed != 1 &&
            courseDetailsJSON.DataSet.courseModule.CourseModule[
               loginCourseModuleID
            ]
         ) {
            isCompleteCount = isCompleteCount + 1;
            const mName =
               courseDetailsJSON.DataSet.courseModule.CourseModule[
                  loginCourseModuleID
               ].CourseModuleName;
            logger(`MODULE NAME:: ${mName}} Completed Status :: false`);
         }
      }
      logger(`Completed Count :: ${isCompleteCount}`);

      return isCompleteCount;
   } catch (error) {
      return isCompleteCount;
   }
}
export function canPreTest({cm}) {
   let isCanPreTest = false;
   const isPreTestAvailable = cm.PreTestAvailable;
   const isPreTestPassed = cm.PreTestPassed === 'false' ? false : true;
   const isPreTestFailed = cm.PreTestFailed === 'false' ? false : true;
   if (isPreTestAvailable && !isPreTestPassed && !isPreTestFailed) {
      if (cm.CourseModuleComplete) {
         isCanPreTest = false;
      } else {
         isCanPreTest = true;
      }
   }
   logger('Pre test enable :: ', {isCanPreTest, cm});
   return isCanPreTest;
}
